import axios from 'axios'
import { apiUrl } from '../utils/apiUrl'

const baseUrl = apiUrl('1ee281dca6cb550566323209969df3eef24d309d072e881a35628ab0d6a54548')
// const baseUrl = 'https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/1ee281dca6cb550566323209969df3eef24d309d072e881a35628ab0d6a54548'

export const updateConsent = async (token) => {

  const { data } = await axios.get(baseUrl, {
    headers: {
      token
    }
  })

  console.log('consent', data)

  return data
}